<template>
    <div class="user-login">
        <div class="top">
            <div class="container">
                <img @click="pageHome" :src="BASE_URL + logo_url" alt="logo">
            </div>
        </div>

        <div class="login-main" :class="{enUsActive: (isEnglish)}">
            <div class="container">
                <div v-show="!showRegister" class="register-main">
                    <el-form
                            label-position="right"
                            :hide-required-asterisk="false"
                            :model="registerForm"
                            :rules="registerRules"
                            ref="registerForm"
                            label-width="85px">
                        <p>
                            <span>{{$t('register.hasAccount')}}</span>
                            <span @click="gotoLogin">{{$t('register.back')}}</span>
                        </p>
                        <el-form-item :label="$t('register.username')" prop="name">
                            <el-input :maxlength="isEnglish ? 40 : 20" v-model.trim="registerForm.name"
                                      :placeholder="$t('register.namePl')" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('register.gender')" prop="sex">
                            <el-radio-group v-model="registerForm.sex">
                                <el-radio :label="1">{{$t('register.male')}}</el-radio>
                                <el-radio :label="2">{{$t('register.female')}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="$t('register.department')" prop="org_id">
                            <el-cascader width="100%" :placeholder="$t('register.inputDepartment')"
                            v-model="registerForm.org_id" 
                            :props="orgProps"
                            :show-all-levels="false"
                            clearable
                            :options="orgOptions"
                            @change="handleChange"></el-cascader>
                        </el-form-item>
                        <el-form-item :label="$t('register.account')" prop="number">
                            <el-input maxlength="16" v-model.trim="registerForm.number"
                                      :placeholder="$t('rules.account')" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('register.psw')" prop="Tpassword">
                            <el-input type="password" maxlength="16" v-model.trim="registerForm.Tpassword"
                                      :placeholder="$t('register.spwdHolder')" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('register.checkPsw')" prop="repassword">
                            <el-input type="password" maxlength="16" v-model.trim="registerForm.repassword"
                                      :placeholder="$t('register.checkPswPl')" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="registerAccount('registerForm')">
                                {{$t('register.submit')}}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>

        <el-dialog :title="$t('global.tips')" :width="isEnglish ? '500px' : '400px'" :visible.sync="affirmAgain">
            <p class="clear">
                <span>{{$t('register.rememberTip')}}</span>
                <span class="fr" @click="copyInfo">{{$t('global.copy')}}</span>
            </p>

            <div class="clear">
                <span class="fl">{{$t('register.account')}}：</span>
                <input readonly type="text" class="account fr" :value="registerForm.number">
            </div>

            <div class="clear">
                <span class="fl">{{$t('register.psw')}}：</span>
                <input readonly type="text" class="fr" :value="registerForm.Tpassword">
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="affirmAgain = false">{{$t('global.cancel')}}</el-button>
                <el-button type="primary" :disabled="createAgain" @click="createAccount">{{$t('register.confirmed')}}
                </el-button>
            </div>
        </el-dialog>

        <foote/>
    </div>
</template>

<script>
    import store from "../../store/index.js";
    import foote from '@/components/common/footer';

    export default {
        data() {
            let validateAccount = (rule, value, callback) => {
                const reg = /^[\w]{4,16}$/;
                if (value === '') {
                    callback(new Error(this.$t('rules.account')));
                } else if (!reg.test(value)) {
                    callback(new Error(this.$t('rules.account')));
                } else {
                    callback();
                }
            };

            let validatePass = (rule, value, callback) => {
                const reg = /^(?![\da-z]+$)(?![\dA-Z]+$)(?![\d!@.#$%^&*]+$)(?![a-zA-Z]+$)(?![a-z!@.#$%^&*]+$)(?![A-Z!@.#$%^&*]+$)[\da-zA-z!@.#$%^&*]{8,16}$/;
                if (value === '') {
                    callback(new Error(this.$t('register.pswEmpty')));
                } else if (!reg.test(value)) {
                    callback(new Error(this.$t('register.strongPwd')));
                } else {
                    callback();
                }
            };

            let validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error(this.$t('register.checkTwice')));
                } else if (value !== this.registerForm.Tpassword) {
                    callback(new Error(this.$t('register.noSame')));
                } else {
                    callback();
                }
            };

            return {
                host_addr: sessionStorage.getItem('host_addr'),
                orgOptions: [],
                orgProps: {
                    label: 'name',
                    value: 'id',
                    checkStrictly: true,
                },
                logo_url: "",   //logo地址
                showRegister: false,
                registerForm: {
                    name: '',   // 用户名
                    sex: 1,   // 性别, 男1，女2
                    org_id:'',  //部门
                    number: '',   // 账号
                    Tpassword: '',   // 密码
                    repassword: '',  // 确认密码
                    role_id: 6
                },
                registerRules: {
                    org_id: [],
                    name: [
                        {required: true, message: this.$t('register.nameEmpty'), trigger: 'blur'},
                        // { required: true, validator: validateName, trigger: 'blur' },
                    ],
                    sex: [
                        {required: true, message: this.$t('register.genderEmpty'), trigger: 'blur'},
                    ],
                    number: [
                        {required: true, validator: validateAccount, trigger: 'blur'},
                    ],
                    Tpassword: [
                        {required: true, validator: validatePass, trigger: 'blur'},
                    ],
                    repassword: [
                        {required: true, message: this.$t('register.pswEmpty'), trigger: 'blur'},
                        {validator: validatePass2, trigger: 'blur'},
                    ],
                },
                affirmAgain: false,
                createAgain: false
            }
        },
        created() {
            this.getLogo();
            this.getOrg();
        },
        computed: {
			isEnglish() {
				return this.$i18n.locale === 'en-us'
			}
		},
        components: {
            foote
        },
        methods: {
            gotoLogin() {
                // console.log(this.host_addr, '回登录页',this.host_addr + '/user-login')
                // window.location.href = this.host_addr + '/user-login'
                this.$router.replace({path: '/user-login'})
            },
            //获取组织架构
            getOrg() {
                let success = res => {
                    this.orgOptions = res.data;
                };
                this.$ajax({
                    url: "api/org/org",
                    method: "get",
                    params: {
                        for_company: 1
                    },
                    func: {success: success}
                });
            },
            //选择部门
            handleChange(value) {
                // console.log(value);
                this.registerForm.org_id = value ? value[value.length - 1] : ''
                // console.log(this.registerForm.org_id)
            },
            //获取logo
            getLogo() {
                let success = res => {
                    this.logo_url = res.data[0].f_logo;
                };
                this.$ajax({
                    url: "api/system/get_logo",
                    method: "get",
                    params: {},
                    func: {success: success}
                });
            },
            // 点击logo事件
            pageHome() {},
            registerAccount(name) {
                this.$refs[name].validate((valid) => {

                    if (valid) {
                        this.affirmAgain = true
                    } else {

                    }
                });
            },
            copyInfo() {
                let content = document.querySelector('.account');
                content.select();
                document.execCommand('copy');
                this.$message.success(this.$t('global.copySuccess'))
            },
            // 创建角色
            createAccount() {
                this.createAgain = true;
                let success = (res => {
                    this.affirmAgain = false;
                    this.$message.success(this.$t('homepage.Moderated'))
                    this.$router.back();
                    return
                    this.showRegister = false;
                    this.$refs.ruleForm.clearValidate();
                    this.createAgain = false;
                    this.registerForm = {
                        name: '',   // 用户名
                        sex: 1,   // 性别, 男1，女2
                        org_id:'',  //部门
                        number: '',   // 账号
                        Tpassword: '',   // 密码
                        repassword: '',  // 确认密码
                        role_id: 6
                    }
                });

                let fail = err => {
                    this.$message.error(err.msg);
                    this.createAgain = false;
                };

                let params = this.registerForm

                this.$ajax({
                    url: 'api/user/user_apply',
                    method: 'post',
                    data: params,
                    func: {success, fail}
                })
            },

        }
    }
</script>

<style lang="scss">
    .user-login {
        display: flex;
        flex-direction: column;
        height: 100vh;
        min-width: 1152px;
        min-height: 880px;
        background: #fff;

        .top {
            background: #fff;

            .container {
                margin: 0 auto;
                width: 1152px;
                height: 120px;

                img {
                    margin-top: 18px;
                    // width: 235px;
                    height: 48px;
                    cursor: pointer;
                    object-fit: contain;
                }

            }

        }

        .login-main {
            flex: 1;
            min-width: 100%;
            min-height: 700px;
            background: url('../../assets/images/login_cn_back.png') center top no-repeat;

            .container {
                position: relative;
                margin: 0 auto;
                width: 1152px;
                height: 100%;

                .register-main {
                    position: absolute;
                    top: 130px;
                    left: 50%;
                    transform: translate(-50%);
                    width: 480px;
                    background: #4477C3;
                    padding-top: 10px;
                    border-radius: 4px;

                    .el-form {
                        height: 100%;
                        background: #E9EEF3;
                        padding: 0 36px 2px;

                        .el-cascader--medium{
                            width: 100%;
                        }

                        > p {
                            padding-top: 38px;
                            line-height: 16px;
                            text-align: right;

                            > span {
                                &:nth-child(1) {
                                }

                                &:nth-child(2) {
                                    margin-bottom: 0;
                                    margin-left: 9px;
                                    color: #4477C3;
                                    cursor: pointer;
                                }

                            }

                        }

                        .el-form-item {
                            margin-bottom: 28px;

                            &:first-of-type {
                                margin-top: 27px;
                            }

                            &:last-of-type {
                                margin-top: 30px;

                                .el-form-item__content {
                                    margin: 0 !important;

                                    .el-button {
                                        width: 100%;
                                        background: #4477C3;
                                        border: 0 none;

                                        &.disabled {
                                            background-color: gray;
                                        }

                                    }

                                }

                            }

                            .el-form-item__label {

                            }

                            .el-form-item__content {
                                .el-input__inner {
                                }
                            }

                        }

                    }

                }

            }

        }
        .enUsActive {
            background: url('../../assets/images/login_back.png') center top no-repeat;
        }

        .el-dialog {
            margin-top: 300px !important;


            .el-dialog__header {
                padding: 0 22px;
                height: 36px;
                background: #4477C3;

                .el-dialog__title {
                    line-height: 36px;
                    font-size: 14px;
                    color: #fff;
                }

                .el-dialog__headerbtn {
                    top: 7px;
                    right: 9px;

                    .el-dialog__close.el-icon.el-icon-close {
                        color: #fff;
                    }

                }

            }

            .el-dialog__body {
                padding: 27px 45px;

                > p {
                    line-height: 16px;
                    font-size: 12px;
                    color: #666666;
                    cursor: pointer;

                    > span {
                        &:first-child {
                        }

                        &:last-child {
                            font-size: 14px;
                            color: #4477C3;
                        }

                    }

                }

                > div {
                    margin-top: 20px;
                    height: 40px;
                    line-height: 40px;

                    > span {
                        font-size: 14px;
                        color: #000;

                    }

                    > input {
                        float: right;
                        box-sizing: border-box;
                        display: inline-block;
                        padding: 0 13px;
                        width: 260px;
                        height: 40px;
                        border: 1px solid #ddd;
                        background: #F8F8F8;
                        border-radius: 2px;
                    }

                }

            }

            .el-dialog__footer {
                padding: 0;

                .dialog-footer {
                    padding: 7px 0 30px;
                    text-align: center;
                    font-size: 22px;

                    .el-button.el-button--default {
                        width: 82px;
                        color: #5E86AB;
                        background: #DEEFFF;
                        border: 0 none;
                    }

                    .el-button.el-button--primary {
                        min-width: 170px;
                        color: #fff;
                        background: #4477C3;
                        border: 0 none;
                    }

                }

            }

        }

    }

    .lang-en-us {
        .register-main {
            width: 580px !important;

            .el-form-item__label {
                width: 200px !important;
            }

            .el-form-item__content {
                margin-left: 200px !important;
            }
        }
    }
</style>
